<template>
    <TemplateBase
        v-if="entry"
        :key="entry.id"
        class="template template--detail"
    >
        <template #hero>
            <slot
                v-if="hero"
                name="hero"
            >
                <DetailHero
                    :breadcrumb-link="breadcrumb.uri"
                    :breadcrumb-label="breadcrumb.label"
                    :title="entry.projectHero?.[0]?.title"
                    :description="entry.projectHero?.[0]?.subtitle"
                    :image="entry.projectHero?.[0]?.image?.[0]"
                    :markermask="entry.projectHero?.[0]?.markermask"
                >
                    <template v-if="entry?.neighbourhoodRelation?.[0]" #label>
                        <BuurtLabel :buurt="entry?.neighbourhoodRelation?.[0]" />
                    </template>
                </DetailHero>
            </slot>
        </template>

        <template #default>
            <slot>
                <ContentBlocks v-if="entry?.contentBlocks" :content-blocks="entry.contentBlocks" />
            </slot>

            <NewsletterSignup v-if="entry.newsletterSignupVisible" />
            <CtaCardsBlock v-if="entry.ctaCardsVisible" />
        </template>
    </TemplateBase>
</template>

<script setup>
const props = defineProps({
    entry: {
        type: Object,
        default: () => {},
        required: true
    }
});

const { entry } = toRefs(props);

const hero = computed(() => {
    if (entry.value?.defaultHero?.[0]) {
        return entry.value.defaultHero[0];
    } else if (entry.value?.projectHero?.[0]) {
        return entry.value.projectHero[0];
    }
});

const breadcrumb = computed(() => {
    if (entry.value?.sectionHandle === 'projects') {
        return {
            label: 'Buurtprojecten',
            uri: '/buurtprojecten'
        };
    } else if (entry.value?.sectionHandle === 'news') {
        return {
            label: 'Nieuws',
            uri: '/nieuws'
        };
    } else if (entry.value?.sectionHandle === 'agenda') {
        return {
            label: 'Agenda',
            uri: '/agenda'
        };
    } else if (entry.value?.parent?.title) {
        return {
            label: entry.value?.parent?.title,
            uri: `/${entry.value?.parent?.uri}`
        };
    }
});

</script>
